// extracted by mini-css-extract-plugin
export var closeButton = "_hu-1";
export var closeX = "_hu-3";
export var container = "_hu-0";
export var image = "_hu-2";